/** Build a Gmail web deep-link that searches by the RFC-822 Message-ID, or null when we don't have one. */
export function gmailSearchUrl(rfc822MessageId: string | null | undefined): string | null {
  if (!rfc822MessageId) return null;
  return `https://mail.google.com/mail/u/0/#search/rfc822msgid:${encodeURIComponent(rfc822MessageId)}`;
}
